import * as req from 'api/actions';
import * as c from './constant';

export const getNewBusinessesList = (payload = { sort_by: 'desc' }, callback) =>
  req.list(
    c.GET_NEW_BUSINESSES,
    '/api/v1/bpls/administrator/businesses',
    payload,
    callback
  );

export const getSingleNewBusinesses = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_NEW_BUSINESSES,
    `/api/v1/bpls/administrator/businesses/${id}`,
    payload,
    callback
  );

export const createNewBusinesses = (payload, callback) =>
  req.create(
    c.CREATE_NEW_BUSINESSES,
    '/api/v1/bpls/administrator/businesses',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateNewBusinesses = (id, payload, callback) =>
  req.update(
    c.UPDATE_NEW_BUSINESSES,
    `/api/v1/bpls/administrator/businesses/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeNewBusinesses = (id, payload, callback) =>
  req.remove(
    c.REMOVE_NEW_BUSINESSES,
    `/api/v1/bpls/administrator/businesses/${id}`,
    payload,
    callback
  );

// business activities

export const getNewBusinessActivitiesList = (id, payload, callback) =>
  req.list(
    c.GET_NEW_BUSINESS_ACTIVITIES,
    `/api/v1/bpls/administrator/businesses/${id}/activities`,
    payload,
    callback
  );

export const createNewBusinessActivities = (id, payload, callback) =>
  req.create(
    c.CREATE_NEW_BUSINESS_ACTIVITIES,
    `/api/v1/bpls/administrator/businesses/${id}/activities`,
    payload,
    callback
  );

export const updateNewBusinessActivities = (
  id,
  businessActivitiesId,
  payload,
  callback
) =>
  req.update(
    c.UPDATE_NEW_BUSINESS_ACTIVITIES,
    `/api/v1/bpls/administrator/businesses/${id}/activities/${businessActivitiesId}`,
    payload,
    callback
  );

export const removeNewBusinessActivities = (
  id,
  businessActivitiesId,
  payload,
  callback
) =>
  req.remove(
    c.REMOVE_NEW_BUSINESS_ACTIVITIES,
    `/api/v1/bpls/administrator/businesses/${id}/activities/${businessActivitiesId}`,
    payload,
    callback
  );

export const getNewBusinessNatureIdList = (payload, callback) =>
  req.list(
    c.GET_NEW_BUSINESS_NATURE_ID,
    `/api/v1/bpls/administrator/common/business_natures`,
    payload,
    callback
  );

export const getNewBusinessLineIdList = (payload, callback) =>
  req.list(
    c.GET_NEW_BUSINESS_LINE_ID,
    `/api/v1/bpls/administrator/common/business_lines`,
    payload,
    callback
  );

export const getNecessaryFieldsList = (payload, callback) =>
  req.list(
    c.GET_NECESSARY_FIELD_LIST,
    `/api/v1/bpls/administrator/common/neccessary_fields`,
    payload,
    callback
  );

export const getTaxPayerList = (payload, callback) =>
  req.list(
    c.GET_TAXPAYER_LIST,
    `/api/v1/bpls/administrator/common/tax_payers`,
    payload,
    callback
  );

export const holdBusiness = (id, payload, callback) =>
  req.update(
    c.HOLD_BUSINESS,
    `/api/v1/bpls/administrator/businesses/${id}/toggle_hold_business`,
    payload,
    callback
  );

export const getVeterinaryFeeList = (payload, callback) =>
  req.list(
    c.GET_VETERINARY_FEE_LIST,
    `/api/v1/bpls/administrator/common/veterinary_registrations`,
    payload,
    callback
  );

export const updateBusinessAssign = (id, payload, callback) =>
  req.create(
    c.UPDATE_BUSINESS_ASSIGN,
    `/api/v1/bpls/administrator/businesses/${id}/assign_taxpayer`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getBusinessAuditLogs = (id, payload, callback) =>
  req.list(
    c.GET_BUSINESS_AUDIT_LOGS,
    `/api/v1/bpls/administrator/businesses/${id}/logs`,
    payload,
    callback
  );

export const addTaxCredit = (id, payload, callback) =>
  req.create(
    c.ADD_TAX_CREDIT,
    `/api/v1/bpls/administrator/businesses/${id}/add_tax_credit`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateTaxCredit = (id, payload, callback) =>
  req.update(
    c.UPDATE_TAX_CREDIT,
    `/api/v1/bpls/administrator/businesses/${id}/update_latest_tax_credit`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const toggleBusinessRetirement = (id, payload, callback) =>
  req.create(
    c.TOGGLE_BUSINESS_RETIREMENT,
    `/api/v1/bpls/administrator/businesses/${id}/toggle_retirement`,
    payload,
    callback
  );

export const toggleActivityRetirement = (id, activityId, payload, callback) =>
  req.create(
    c.TOGGLE_ACTIVITY_RETIREMENT,
    `/api/v1/bpls/administrator/businesses/${id}/activities/${activityId}/toggle_retirement`,
    payload,
    callback
  );

export const updateVeterinaryFee = (id, payload, callback) =>
  req.create(
    c.UPDATE_VETERINARY_FEE,
    `/api/v1/bpls/administrator/businesses/${id}/update_field`,
    payload,
    callback
  );

export const getBusinessNecessaryField = (payload, callback) =>
  req.list(
    c.GET_BUSINESS_NECESSARY_FIELD,
    `/api/v1/bpls/administrator/common/business_necessary_fields`,
    payload,
    callback
  );

export const getBusinessLinesList = (payload, callback) =>
  req.list(
    c.GET_BUSINESS_LINES_LIST,
    `/api/v1/bpls/administrator/common/business_lines`,
    payload,
    callback
  );

export const removeBusinessApplication = (
  id,
  applicationId,
  payload,
  callback
) =>
  req.remove(
    c.REMOVE_BUSINESS_APPLICATION,
    `/api/v1/bpls/administrator/businesses/${id}/applications/${applicationId}`,
    payload,
    callback
  );

export const removeUser = (id, payload, callback) =>
  req.create(
    c.REMOVE_USER,
    `/api/v1/bpls/administrator/businesses/${id}/unassign_taxpayer`,
    payload,
    callback
  );

export const getFeesList = (id, applicationId, payload, callback) =>
  req.list(
    c.GET_FEES_LIST,
    `/api/v1/bpls/administrator/businesses/${id}/applications/${applicationId}/fees`,
    payload,
    callback
  );

export const deleteApplicationFees = (id, applicationId, payload, callback) =>
  req.remove(
    c.DELETE_APPLICATION_FEES,
    `/api/v1/bpls/administrator/businesses/${id}/applications/${applicationId}/fees`,
    payload,
    callback
  );

export const onRevoke = (id, applicationId, payload, callback) =>
  req.create(
    c.REVOKE_PERMIT,
    `/api/v1/bpls/administrator/businesses/${id}/applications/${applicationId}/toggle_revoke_permit`,
    payload,
    callback
  );

export const onRevokeBarangayClearance = (
  id,
  applicationId,
  payload,
  callback
) =>
  req.create(
    c.REVOKE_PERMIT_BARANGAY_CLEARANCE,
    `/api/v1/bpls/administrator/businesses/${id}/applications/${applicationId}/toggle_revoke_barangay_clearance`,
    payload,
    callback
  );

export const validate = (id, activityId, payload, callback) =>
  req.create(
    c.VALIDATE,
    `/api/v1/bpls/administrator/businesses/${id}/activities/${activityId}/validate`,
    payload,
    callback
  );

export const deductTaxCredit = (id, payload, callback) =>
  req.remove(
    c.DEDUCT_TAX_CREDIT,
    `/api/v1/bpls/administrator/businesses/${id}/tax_credits`,
    callback,
    {},
    payload,
  );
